export const Loading = () => {
  return (
    <div className="flex flex-col items-center gap-5">
      <p className="text-xl font-bold text-accent">Loggar in</p>
      <span className="loading loading-ring loading-lg text-primary"></span>
    </div>
  );
};
